<template>
<w-tree-layout :auto-scroll="autoScroll" :is-checkbox-tree="true">
  <w-search-field v-if="showSearchTool === true" ref="searchField" slot="search" class="title-bar" :width="searchWidth" @search="onSearch"/>
  <el-tree
    slot="tree"
    ref="tree"
    class="tree-checkbox"
    :data="treeData"
    show-checkbox
    :props="defaultProps"
    :node-key="defaultProps.treeKey"
    :expand-on-click-node="false"
    :highlight-current="highlightCurrent"
    :filter-node-method="filterNode"
    @check-change="onCheckChange"
    >
    <span slot-scope="{ node, data }" class="el-tree-node__label">
      <span>{{getNodeLabel(data)}}</span>
    </span>
  </el-tree>
</w-tree-layout>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import clone from 'lodash/clone';
import TreeAPI from '@/api/common/tree';
import TreeFilter from '@/mixins/tree/filter';
import { defaultProps } from '@/constants/tree';
import { isObjNode, isRequireIPObjType, getObjNodeLabel } from '@/utils/tree';
import WSearchField from '@/components/form/SearchField';
import WTreeLayout from '@/components/tree/components/TreeLayout';

const EVENT_CONST = {
  CHECKED: 'checked',
  LOAD: 'load',
};
export default {
  name: 'WCheckPhysicalTree',
  components: {
    WSearchField,
    WTreeLayout,
  },
  mixins: [TreeFilter],
  props: {
    managetypeId: {
      type: [String, Object],
      default: null,
    },
    managetypeKey: {
      type: [String, Object],
      default: null,
    },
    expandOnClickNode: {
      type: Boolean,
      default: true,
    },
    highlightCurrent: {
      type: Boolean,
      default: true,
    },
    showSearchTool: {
      type: Boolean,
      default: true,
    },
    searchWidth: {
      type: String,
      default: '100%',
    },
    autoScroll: {
      type: Boolean,
      default: true,
    },
    /**
     * 선택된 노드 관리 시 필터링된 노드 기준으로 제공 여부
     * true일 경우 checked 이벤트에서 체크된 노드 중 필터링된 노드 배열을 반환하며, 검색 시 checked 이벤트를 emit 한다.
     */
    baseFilterNode: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      treeData: [],
      defaultProps,
      treeRef: 'tree',
    };
  },
  watch: {
    managetypeId: {
      handler(to) {
        if (!isEmpty(to) && isEmpty(this.managetypeKey)) {
          this.loadData();
        }
      },
    },
    managetypeKey: {
      handler(to) {
        if (!isEmpty(to)) {
          this.loadData();
        }
      },
    },
  },
  created() {
    if (!isEmpty(this.managetypeId)) {
      this.loadData();
    }
  },
  methods: {
    isObjNode,
    isRequireIPObjType,
    getObjNodeLabel,
    getTree() {
      return this.$refs[this.treeRef];
    },
    loadData() {
      TreeAPI.getPhysicalTreeData({
        managetypeId: this.managetypeId,
        managetypeKey: this.managetypeKey,
      }).then((response) => {
        if (!isEmpty(response.data) && response.data.success === true && !isEmpty(response.data.children)) {
          this.treeData = [response.data.children];
          // load시 마다 선택된 노드 유지되도록 함. (또는 watch 이용)
          this.$nextTick(() => {
            const root = this.$refs[this.treeRef].getNode(this.managetypeId);
            if (!isEmpty(root)) {
              root.expanded = true;
            }
            this.$emit(EVENT_CONST.LOAD);
          });
        } else {
          this.treeData = [];
        }
      });
    },
    onCheckChange() { // node, checked
      if (this.baseFilterNode) {
        this.$emit(EVENT_CONST.CHECKED, this.$refs[this.treeRef].getFilteredCheckedNodes().length, this.getFilteredCheckedNodes());
      } else {
        this.$emit(EVENT_CONST.CHECKED, this.$refs[this.treeRef].getCheckedNodes().length, this.getCheckedNodes());
      }
    },
    getFilteredCheckedNodes() {
      return this.$refs[this.treeRef].getFilteredCheckedNodes();
    },
    getCheckedNodes() {
      return this.$refs[this.treeRef].getCheckedNodes();
    },
    getCheckedObjList() {
      const nodes = this.baseFilterNode ? this.getFilteredCheckedNodes() : this.getCheckedNodes();
      if (!isEmpty(nodes)) {
        const checkedObjList = [];
        forEach(nodes, (node) => {
          if (node.type === 'obj') {
            checkedObjList.push(clone(node.obj));
          }
        });
        return checkedObjList;
      }
      return null;
    },
    setTreeParams(params) {
      this.params = params;
    },
    getNodeLabel(data) {
      return this.isObjNode(data) && this.isRequireIPObjType(data) ? this.getObjNodeLabel(data) : data.label;
    },
    getSearchField() {
      return this.$refs.searchField;
    },
    onSearch(value) {
      this.filterTree(value);
      this.onCheckChange();
    },
    clearData() {
      this.treeData = [];
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/tree/CheckPhysicalTree.vue